<template>
  <div>
    <loading v-show="showLoader" />

    <div class="ib-main-section">
      <div class="container">
        <router-link class="ib-back-btn" :to="{ name: 'PolicyServicing' }">Back</router-link>
        <div class="row">
          <div class="col-md-6 pl-0">
            <div class="d2c-class-container" style="padding-top: 77px;">
              <!-- Nav tabs -->
              <h2 class="listing-page-title">Policy Servicing</h2>
              <h2 class="listing-page-desc text-capitalize">{{ endorsementRequest.endorsement_type.toLowerCase().split("_").join(" ") }} Detail</h2>

            </div>
          </div>
          <div class="col-md-6 in-page-infographic">
            <img class="img-fluid" alt="icon" :src="require('@/assets/images/claim-policy-right-img.svg')" />
          </div>
        </div>
      </div>
      <div class="container">
        <div class="row">
        <div class="col-md-12">
          <div class="container multistep-box" style="margin: 50px auto 20px; text-align: center;">
            <div class="row mb-4">
              <div class="col-12 ib-border-b">
                <ul class="list-inline">
                  <li class="mb-3 mb-md-0"><h1 class="ib-claim-listing">Submitted Request</h1> <span class="status status-in-process" style="float: right; position: relative; bottom: 30px; width:6rem !important;">{{ endorsementRequest.endorsement_request.status }}</span>
                  </li>
                </ul>
              </div>
              <div class="col-md-12 d-none d-md-block" v-if="endorsementRequest.endorsement_type == 'cancellation'">
                <div class="container endorsement-table">
                  <div class="row" >
                  <div class="col-md-6">
                    Policy Id
                  </div>
                  <div class="col-md-6">
                    {{ endorsementRequest.customer_quotation_id}}
                  </div>
                </div>
                  <div class="row" >
                  <div class="col-md-6">
                    Reason
                  </div>
                  <div class="col-md-6">
                    {{ endorsementRequest.reason}}
                  </div>
                </div>
                <div class="row" >
                  <div class="col-md-6">
                    Submitted Date
                  </div>
                  <div class="col-md-6">
                    {{ endorsementRequest.endorsement_request.submitted_date }}
                  </div>
                </div>
                <div class="row" v-if="endorsementRequest.endorsement_request.status != 'pending'">
                  <div class="col-md-6">
                    Action Date
                  </div>
                  <div class="col-md-6">
                    {{ endorsementRequest.endorsement_request.action_date }}
                  </div>
                </div>
                </div>
              </div>
              <div class="col-md-12 d-none d-md-block" v-if="endorsementRequest.endorsement_type == 'beneficiary'">
                <div class="container endorsement-table">
                  <div class="row" v-if="endorsementRequest.first_name != null" >
                  <div class="col-md-6">
                    First Name
                  </div>
                  <div class="col-md-6">
                    {{ endorsementRequest.first_name}}
                  </div>
                </div>
                <div class="row" v-if="endorsementRequest.old_first_name != null" >
                  <div class="col-md-6">
                    Old First Name
                  </div>
                  <div class="col-md-6">
                    {{ endorsementRequest.old_first_name}}
                  </div>
                </div>

                <div class="row" v-if="endorsementRequest.last_name != null" >
                  <div class="col-md-6">
                    Last Name
                  </div>
                  <div class="col-md-6">
                    {{ endorsementRequest.last_name}}
                  </div>
                </div>
                <div class="row" v-if="endorsementRequest.old_last_name != null" >
                  <div class="col-md-6">
                    Old Last Name
                  </div>
                  <div class="col-md-6">
                    {{ endorsementRequest.old_last_name}}
                  </div>
                </div>

                <div class="row" v-if="endorsementRequest.cnic != null" >
                  <div class="col-md-6">
                    CNIC
                  </div>
                  <div class="col-md-6">
                    {{ endorsementRequest.cnic}}
                  </div>
                </div>
                <div class="row" v-if="endorsementRequest.old_cnic != null" >
                  <div class="col-md-6">
                    Old CNIC
                  </div>
                  <div class="col-md-6">
                    {{ endorsementRequest.old_cnic}}
                  </div>
                </div>

                <div class="row" v-if="endorsementRequest.mobile_no != null" >
                  <div class="col-md-6">
                    Mobile No
                  </div>
                  <div class="col-md-6">
                    {{ endorsementRequest.mobile_no}}
                  </div>
                </div>
                <div class="row" v-if="endorsementRequest.old_mobile_no != null" >
                  <div class="col-md-6">
                    Old Mobile No
                  </div>
                  <div class="col-md-6">
                    {{ endorsementRequest.old_mobile_no}}
                  </div>
                </div>

                <div class="row" v-if="endorsementRequest.address != null" >
                  <div class="col-md-6">
                    Address
                  </div>
                  <div class="col-md-6">
                    {{ endorsementRequest.address}}
                  </div>
                </div>
                <div class="row" v-if="endorsementRequest.old_address != null" >
                  <div class="col-md-6">
                    Old Address
                  </div>
                  <div class="col-md-6">
                    {{ endorsementRequest.old_address}}
                  </div>
                </div>

                <div class="row" v-if="endorsementRequest.email != null" >
                  <div class="col-md-6">
                    Email
                  </div>
                  <div class="col-md-6">
                    {{ endorsementRequest.email}}
                  </div>
                </div>
                <div class="row" v-if="endorsementRequest.old_email != null" >
                  <div class="col-md-6">
                    Old Email
                  </div>
                  <div class="col-md-6">
                    {{ endorsementRequest.old_email}}
                  </div>
                </div>

                <div class="row" v-if="endorsementRequest.cnic_expiry_date != null" >
                  <div class="col-md-6">
                    Cnic Expiry Date
                  </div>
                  <div class="col-md-6">
                    {{ endorsementRequest.cnic_expiry_date}}
                  </div>
                </div>
                <div class="row" v-if="endorsementRequest.old_cnic_expiry_date != null" >
                  <div class="col-md-6">
                    Old Cnic Expiry Date
                  </div>
                  <div class="col-md-6">
                    {{ endorsementRequest.old_cnic_expiry_date}}
                  </div>
                </div>

                <div class="row" v-if="endorsementRequest.cnic_issue_date != null" >
                  <div class="col-md-6">
                    Cnic Issue Date
                  </div>
                  <div class="col-md-6">
                    {{ endorsementRequest.cnic_issue_date}}
                  </div>
                </div>
                <div class="row" v-if="endorsementRequest.old_cnic_issue_date != null" >
                  <div class="col-md-6">
                    Old Cnic Issue Date
                  </div>
                  <div class="col-md-6">
                    {{ endorsementRequest.old_cnic_issue_date}}
                  </div>
                </div>

                <div class="row" v-if="endorsementRequest.gender != null" >
                  <div class="col-md-6">
                    Gender
                  </div>
                  <div class="col-md-6">
                    {{ endorsementRequest.gender}}
                  </div>
                </div>
                <div class="row" v-if="endorsementRequest.old_gender != null" >
                  <div class="col-md-6">
                    Old Gender
                  </div>
                  <div class="col-md-6">
                    {{ endorsementRequest.old_gender}}
                  </div>
                </div>

                <div class="row" v-if="endorsementRequest.dob != null" >
                  <div class="col-md-6">
                    DOB
                  </div>
                  <div class="col-md-6">
                    {{ endorsementRequest.dob}}
                  </div>
                </div>
                <div class="row" v-if="endorsementRequest.old_dob != null" >
                  <div class="col-md-6">
                    Old DOB
                  </div>
                  <div class="col-md-6">
                    {{ endorsementRequest.old_dob}}
                  </div>
                </div>

                <div class="row" v-if="endorsementRequest.relation_id != null" >
                  <div class="col-md-6">
                    Relation
                  </div>
                  <div class="col-md-6">
                    {{ get_relation(endorsementRequest.relation_id) }}
                  </div>
                </div>
                <div class="row" v-if="endorsementRequest.old_relation_id != null" >
                  <div class="col-md-6">
                    Old Relation
                  </div>
                  <div class="col-md-6">
                    {{ get_relation(endorsementRequest.old_relation_id) }}
                  </div>
                </div>

                <div class="row" >
                  <div class="col-md-6">
                    Submitted Date
                  </div>
                  <div class="col-md-6">
                    {{ endorsementRequest.endorsement_request.submitted_date }}
                  </div>
                </div>
                <div class="row" v-if="endorsementRequest.endorsement_request.status != 'pending'">
                  <div class="col-md-6">
                    Action Date
                  </div>
                  <div class="col-md-6">
                    {{ endorsementRequest.endorsement_request.action_date }}
                  </div>
                </div>
                </div>
              </div>

              <div class="col-md-12 d-none d-md-block" v-if="endorsementRequest.endorsement_type == 'family'">
                <div v-if="endorsementRequest.child.length > 0" v-for="(child, index) in endorsementRequest.child">
                  <div class="documents-heading">
                     Child {{ index+1 }}
                  </div>
                  <div class="container endorsement-table">
                    <div class="row" v-if="child.relation != null">
                      <div class="col-md-6">
                        Relation
                      </div>
                      <div class="col-md-6">
                        {{ child.relation}}
                      </div>
                    </div>
                    <div class="row" v-if="child.old_relation != null">
                      <div class="col-md-6">
                        Old Relation
                      </div>
                      <div class="col-md-6">
                        {{ child.old_relation}}
                      </div>
                    </div>

                    <div class="row" v-if="child.name != null">
                      <div class="col-md-6">
                        Name
                      </div>
                      <div class="col-md-6">
                        {{ child.name}}
                      </div>
                    </div>
                    <div class="row" v-if="child.old_name != null">
                      <div class="col-md-6">
                        Old Name
                      </div>
                      <div class="col-md-6">
                        {{ child.old_name}}
                      </div>
                    </div>

                    <div class="row" v-if="child.passport != null">
                      <div class="col-md-6">
                        Passport
                      </div>
                      <div class="col-md-6">
                        {{ child.passport}}
                      </div>
                    </div>
                    <div class="row" v-if="child.old_passport != null">
                      <div class="col-md-6">
                        Old Passport
                      </div>
                      <div class="col-md-6">
                        {{ child.old_passport}}
                      </div>
                    </div>

                    <div class="row" v-if="child.cnic != null">
                      <div class="col-md-6">
                        CNIC
                      </div>
                      <div class="col-md-6">
                        {{ child.cnic}}
                      </div>
                    </div>
                    <div class="row" v-if="child.old_cnic != null">
                      <div class="col-md-6">
                        Old CNIC
                      </div>
                      <div class="col-md-6">
                        {{ child.old_cnic}}
                      </div>
                    </div>

                    <div class="row" v-if="child.dob != null">
                      <div class="col-md-6">
                        DOB
                      </div>
                      <div class="col-md-6">
                        {{ child.dob}}
                      </div>
                    </div>
                    <div class="row" v-if="child.old_dob != null">
                      <div class="col-md-6">
                        Old DOB
                      </div>
                      <div class="col-md-6">
                        {{ child.old_dob}}
                      </div>
                    </div>

                    <div class="row" v-if="child.gender != null">
                      <div class="col-md-6">
                        Gender
                      </div>
                      <div class="col-md-6">
                        {{ child.gender}}
                      </div>
                    </div>
                    <div class="row" v-if="child.old_gender != null">
                      <div class="col-md-6">
                        Old Gender
                      </div>
                      <div class="col-md-6">
                        {{ child.old_gender}}
                      </div>
                    </div>
                  </div>

                </div>

                <div v-if="endorsementRequest.spouse.length > 0" v-for="(spouse, index) in endorsementRequest.spouse">
                  <div class="documents-heading">
                    Spouse {{ index+1 }}
                  </div>
                  <div class="container endorsement-table">
                    <div class="row" v-if="spouse.relation != null">
                      <div class="col-md-6">
                        Relation
                      </div>
                      <div class="col-md-6">
                        {{ spouse.relation}}
                      </div>
                    </div>
                    <div class="row" v-if="spouse.old_relation != null">
                      <div class="col-md-6">
                        Old Relation
                      </div>
                      <div class="col-md-6">
                        {{ spouse.old_relation}}
                      </div>
                    </div>

                    <div class="row" v-if="spouse.name != null">
                      <div class="col-md-6">
                        Name
                      </div>
                      <div class="col-md-6">
                        {{ spouse.name}}
                      </div>
                    </div>
                    <div class="row" v-if="spouse.old_name != null">
                      <div class="col-md-6">
                        Old Name
                      </div>
                      <div class="col-md-6">
                        {{ spouse.old_name}}
                      </div>
                    </div>

                    <div class="row" v-if="spouse.passport != null">
                      <div class="col-md-6">
                        Passport
                      </div>
                      <div class="col-md-6">
                        {{ spouse.passport}}
                      </div>
                    </div>
                    <div class="row" v-if="spouse.old_passport != null">
                      <div class="col-md-6">
                        Old Passport
                      </div>
                      <div class="col-md-6">
                        {{ spouse.old_passport}}
                      </div>
                    </div>

                    <div class="row" v-if="spouse.cnic != null">
                      <div class="col-md-6">
                        CNIC
                      </div>
                      <div class="col-md-6">
                        {{ spouse.cnic}}
                      </div>
                    </div>
                    <div class="row" v-if="spouse.old_cnic != null">
                      <div class="col-md-6">
                        Old CNIC
                      </div>
                      <div class="col-md-6">
                        {{ spouse.old_cnic}}
                      </div>
                    </div>

                    <div class="row" v-if="spouse.dob != null">
                      <div class="col-md-6">
                        DOB
                      </div>
                      <div class="col-md-6">
                        {{ spouse.dob}}
                      </div>
                    </div>
                    <div class="row" v-if="spouse.old_dob != null">
                      <div class="col-md-6">
                        Old DOB
                      </div>
                      <div class="col-md-6">
                        {{ spouse.old_dob}}
                      </div>
                    </div>

                    <div class="row" v-if="spouse.gender != null">
                      <div class="col-md-6">
                        Gender
                      </div>
                      <div class="col-md-6">
                        {{ spouse.gender}}
                      </div>
                    </div>
                    <div class="row" v-if="spouse.old_gender != null">
                      <div class="col-md-6">
                        Old Gender
                      </div>
                      <div class="col-md-6">
                        {{ spouse.old_gender}}
                      </div>
                    </div>
                  </div>

                </div>

                <div class="container endorsement-table">
                <div class="row">
                  <div class="col-md-6">
                    Submitted Date
                  </div>
                  <div class="col-md-6">
                    {{ endorsementRequest.endorsement_request.submitted_date}}
                  </div>
                </div>
                <div class="row"  v-if="endorsementRequest.endorsement_request.status != 'pending'">
                  <div class="col-md-6">
                    Action Date
                  </div>
                  <div class="col-md-6">
                    {{ endorsementRequest.endorsement_request.action_date}}
                  </div>
                </div>
                </div>
              </div>

              <div class="col-md-12 d-none d-md-block" v-if="endorsementRequest.endorsement_type == 'general_acquisition'">
<!--               //Stage 1-->
                <div v-if="endorsementRequest.form_data.stage_1">
                  <div class="documents-heading">
                    Form Data
                  </div>
                  <div class="container endorsement-table">
                    <div class="row" v-for="field in endorsementRequest.form_data.stage_1">
                      <div class="col-md-6">
                        {{ field.label }}
                      </div>
                      <div class="col-md-6">
                        {{ field.value}}
                      </div>
                    </div>
                  </div>
                </div>
                <div v-if="endorsementRequest.old_form_data.stage_1">
                  <div class="documents-heading">
                    Old Form Data
                  </div>
                  <div class="container endorsement-table">
                    <div class="row" v-for="field in endorsementRequest.old_form_data.stage_1">
                      <div class="col-md-6">
                        {{ field.label }}
                      </div>
                      <div class="col-md-6">
                        {{ field.value}}
                      </div>
                    </div>
                  </div>
                </div>
<!--                //Stage 3-->
                <div v-if="endorsementRequest.form_data.stage_3">
                  <div class="documents-heading">
                    Form Data
                  </div>
                  <div class="container endorsement-table">
                    <div class="row" v-for="field in endorsementRequest.form_data.stage_3">
                      <div class="col-md-6">
                        {{ field.label }}
                      </div>
                      <div class="col-md-6" v-if="field.label.toLowerCase().includes('dob') || field.label.toLowerCase().includes('date') || field.label.toLowerCase().includes('date')">{{ formatDynamicDate(field.value)}}</div>
                      <div class="col-md-6" v-else>{{ field.value}}</div>
                    </div>
                  </div>
                </div>
                <div v-if="endorsementRequest.old_form_data.stage_3">
                  <div class="documents-heading">
                    Old Form Data
                  </div>
                  <div class="container endorsement-table">
                    <div class="row" v-for="field in endorsementRequest.old_form_data.stage_3">
                      <div class="col-md-6">
                        {{ field.label }}
                      </div>
                      <div class="col-md-6" v-if="field.label.toLowerCase().includes('dob') || field.label.toLowerCase().includes('date') || field.label.toLowerCase().includes('date')">{{ formatDynamicDate(field.value)}}</div>
                      <div class="col-md-6" v-else>{{ field.value}}</div>
                    </div>
                  </div>
                </div>
<!--                -&#45;&#45;&#45;&#45;&#45;&#45;-->
                <div class="container endorsement-table">
                <div class="row">
                  <div class="col-md-6">
                    Submitted Date
                  </div>
                  <div class="col-md-6">
                    {{ endorsementRequest.endorsement_request.submitted_date}}
                  </div>
                </div>
                <div class="row"  v-if="endorsementRequest.endorsement_request.status != 'pending'">
                  <div class="col-md-6">
                    Action Date
                  </div>
                  <div class="col-md-6">
                    {{ endorsementRequest.endorsement_request.action_date}}
                  </div>
                </div>
                </div>
                <div class="ib-border-t">
                  <div class="documents-heading">
                    Uploaded Documents
                  </div>
                  <div class="row in-document-flex">
                    <div class="claim-doc-icon" v-for="document in endorsementRequest.documents">
                      <a :href="document.icon" target="_blank">
                        <div class="claim-data-icon">
                          <img class="img-fluid" :src="document.icon">
                          <p>{{ document.field_type.toLowerCase().split("_").join(" ") }}</p>
                        </div>
                      </a>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-md-12 d-none d-md-block ib-border-t" v-if="endorsementRequest.endorsement_request.status == 'approved'">
                <div class="documents-heading">
                  Endorsement Document
                </div>
                <div class="row in-document-flex">
                  <div class="claim-doc-icon">
                    <a :href="endorsementRequest.endorsement_request.pdf" target="_blank">
                      <div class="claim-data-icon">
                        <img class="img-fluid" :src="require('@/assets/images/text-document.svg')">
                        <p>PDF</p>
                      </div>
                    </a>
                  </div>
                </div>
<!--                <a :href="endorsementRequest.endorsement_request.pdf" target="_blank" style="float: left">-->
<!--                  <img style="width: 90px;margin-left: 14px;" class="img-fluid" alt="Endorsement Document" :src="require('@/assets/images/text-document.svg')" />-->
<!--                  <p>PDF Document</p>-->
<!--                </a>-->
              </div>
            </div>
          </div>
        </div>
      </div>
      </div>
    </div>
  </div>
</template>

<script>
import loading from '@/components/Loading/Loading'
import moment from "moment";
import _ from 'lodash';

export default {
  name: 'ViewPolicy',
  components: {
    loading
  },
  data() {
    return {
      showLoader: true,
      endorsementRequest: {},
      endorsement_id: this.$route.params.id,
      beneficiaryRelations: {}
    };
  },
  created: function () {
    const self = this;
    self.getEndorsements(self.quotation_id);
    self.getBeneficiariesData();
  },
  computed: {

    date() {
      return moment().format('YYYY-MM-DD');
    }
  },
  methods: {
    formatDynamicDate(date) {
      return moment(date, 'YYYY-MM-DD').format('DD-MMM-YYYY');
    },
    get_relation(relation_id){
      const self = this;
      let relation =  self.beneficiaryRelations.filter(x => x.id == relation_id);
      return relation[0].name;
    },
    async getBeneficiariesData() {
      const self = this;
      await axios.get('customer/beneficiary_relations').then(function (resp) {
        if(resp.data.code == 200) {
          self.beneficiaryRelations = resp.data.data.beneficiary_relations;
        } else {
          $toast.error(resp.data.message, { position: 'top-right' });
        }
      }).catch(function (error) {
        self.showLoader = false;
        if(error.response) {
          error.response.data.errors.forEach(element => {
            $toast.error(element.message, { position: 'top-right' });
          });
        } else {
          $toast.error(error.data.message, { position: 'top-right' });
        }
      });
    },
    priceFormatter(price) {
      return new Intl.NumberFormat('en-PK').format(price);
    },
    formatDate(date) {
      return moment(date, "YYYY-MM-DD").format('DD-MMM-YYYY');
    },
    async getEndorsements(id) {
      var self = this;
      self.showLoader = true;
      await axios.get('customer/endorsement/request_detail?endorsement_request_id='+ self.endorsement_id).then(function (resp) {
        self.showLoader = false;
        if (resp.data.code == 200) {

          self.endorsementRequest = resp.data.data;
          console.log(self.endorsementRequest.endorsement_type);

        } else {
          $toast.error(resp.data.message, { position: 'top-right' });
          return false;
        }
      }).catch(function (error) {
        self.showLoader = false;
        if(error.data.errors != undefined) {
          error.data.errors.forEach(element => {
            $toast.error(element.message, { position: 'top-right' });
          });
        } else {
          $toast.error(error.data.message, { position: 'top-right' });
        }
      });
    },

  }
};
</script>

<style scoped>
.data-row p {
  color :#5b6770;
}
table > tbody > tr, .data-row {
  margin: 10px 0;
  padding: 20px 30.7px 20px 15px;
  border-radius: 10px;
  border: solid 1px #dedada;
  background-color: #ffffff;
}
.data-row .action-area {
  text-align: right;
}
.data-row .action-area i {
  width: 7.9px;
  height: 14.6px;
  color: #5b6770;
}
.data-row .claim-row-sub-heading {
  color: #a9adaf;
}
.data-row .claim-row-sub-desc {
  color: #5b6770;
}
.data-row .status-danger {
  background-color: rgba(30, 203, 16, 0.09);
  font-size: 12px;
  font-stretch: normal;
  font-style: normal;
  color: #1ecb10;
  letter-spacing: normal;
}
.data-row .status {
  margin: 10px 61.3px 10px 52px;
  padding: 6px 24px;
  border-radius: 6px;
  font-family: "Futura PT";
}
.data-row .claim-row-data {
  font-family: "Futura PT";
  font-size: 17px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: 8px;
  letter-spacing: normal;
  text-align: left;
}
.data-row .claim-row-heading {
  font-family: "Futura PT";
  font-size: 22px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.32;
  letter-spacing: normal;
  text-align: left;
  color: #5b6770;
}
.in-listing-img {
  width: 79px;
  height: 66px;
  background-color: #ecf3f5;
  border-radius: 11px;
  border: 1px solid gainsboro;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
}
.in-listing-img img{
  width: 100% !important;
  max-width: 70px !important;
  max-height: 60px !important;
  height: auto !important;
}

.position-relative-box {
  width: 25px;
  height: 25px;
  border-radius: 50%;
  border: 1px solid gainsboro;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
  position: absolute;
  bottom: -10px;
  right: -10px;
}
.position-relative-box img{
  width: 100% !important;
  max-width: 23px !important;
  height: auto !important;
}
table.claim-listing {
  width: 100%;
  margin: 0 auto;
  font-family: Arial, sans-serif;
  border-collapse: separate;
  border-spacing: 0 10px;
}
table.claim-listing td {
  height: 100px !important;
  vertical-align: middle;
  text-align: center;
  position: relative;
}
@media (max-width:668px) {
  table.claim-listing td:not(:first-child) {
    height: 60px !important;
  }
  table.claim-listing tbody td:first-child{
    height: auto !important;
  }
}
table.claim-listing td:last-child:after {
  content: none;
}
table.claim-listing tbody td {
  border-top: 1px solid #eee;
  border-bottom: 1px solid #eee;
  cursor: pointer;
}
@media (min-width:669px) {
  table.claim-listing tbody td:first-child {
    border-left: 1px solid #eee;
    border-top-left-radius: 10px;
    border-bottom-left-radius: 10px;
  }
  table.claim-listing tbody td:last-child {
    border-right: 1px solid #eee;
    border-top-right-radius: 10px;
    border-bottom-right-radius: 10px;
  }
  table.claim-listing tbody tr {
    box-shadow: 0 3px 26px 0 rgba(0, 0, 0, 0.08);
  }
}
.jbl-table-heading {
  font-family: "Avenir Medium";
  font-weight: 500;
  text-align: left !important;
  font-size: 19px;
  color: #5b6770;
}

.jbl-table-heading span {
  font-weight: normal !important;
  font-size: 10px !important;
  font-weight: 500 !important;
  color: #ef7c94 !important;
}
.jbl-table-heading small {
  font-weight: normal !important;
  font-size: 11px !important;
  font-weight: 500 !important;
  color: #ef7c94 !important;
}
.jbl-date-td {
  font-family: "Avenir Medium";
  font-size: 19px;
  font-weight: 500;
  text-align: left;
  color: #5b6770;
}
.jbl-date-heading {
  color: #ef7c94 !important;
  font-family: "Avenir Book";
  font-size: 13px;
  text-align: left;
}
table.claim-listing .fa-chevron-right {
  padding-right: 2rem;
  color: #5b6770;
}
.jbl-flex-td {
  display: flex;
  flex-direction: column;
}
@media (min-width:668px) and (max-width:992px) {
  .jbl-table-heading {
    font-size: 14px;
  }
  .jbl-date-td {
    font-family:"Futura PT Medium";
    font-size: 12px;
  }
  table.claim-listing .fa-chevron-right {
    padding-right: 1rem;
    color: #5b6770;
  }
}
.d2c-main-classes {
  background-color: #def3f7;
  border-radius: 31px;
  max-width: fit-content;
  margin: 1px 0 30px;
}
.d2c-class-btn {
  display: inline-block;
  margin-bottom: 0;
  text-align: center;
  vertical-align: middle;
  touch-action: manipulation;
  cursor: pointer;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  white-space: nowrap;
  padding: 6px 12px;
  border: 1px solid transparent;
  border-radius: 4px;
  height: 61px;
  margin: 0 0 1px;
  border-radius: 31px;
  background-color: #def3f7;
  font-family: "Avenir Medium";
  font-size: 16px;
  font-weight: 500;
  line-height: 1.38;
  color: #4c505d;
  transition: all .3s ease-in;
}
@media(max-width:550px){
  .d2c-class-btn{
    padding: 6px 22px !important;
    width: max-content !important;
    font-size: 12px !important;
  }
}
.d2c-class-btn:hover {
  background-color: #049cbd;
  color: white;
}
.d2c-class-btn:focus, .d2c-class-btn:active, .d2c-class-btn.active {
  outline: none !important;
  background-color: #049cbd;
  color: white;
}
.nex-Page-Link .fa-chevron-right {
  color: #aeccd6 !important;
  font-weight: normal !important;
}
 .claim-doc-icon p {
    font-family: "Avenir Medium";
    font-size: 14px;
    font-weight: 500;
    font-stretch: normal;
    font-style: normal;
    letter-spacing: normal;
    text-align: left;
    color: #4c505d;
    margin-bottom: 0px;
    text-transform: capitalize;
  }
  .claim-data-icon img {
    margin: 0 auto;
  }
  /* .claim-data-icon {
    width: 121px;
    height: 124px;
    border-radius: 10px;
    border: solid 1px #e5e5e5;
    background-color: #ffffff;
    box-shadow: 0 2px 20px 0 rgba(0, 0, 0, 0.17);
    display: flex !important;
    justify-content: space-evenly;
    align-items: center;
    flex-direction: column;
  } */
  .claim-data-icon img{
    width: 60px;
    margin-top: 8px;
  }
  /* .claim-data-icon:not(:nth-of-type(1)) {
    margin-left: 15px;
    margin-right: 15px;
  } */
  .claim-row-sub-heading {
    font-family: "Avenir Book";
    font-size: 15px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.38;
    letter-spacing: normal;
    text-align: left;
    padding-left: 20px;
    color: #ef7c94;
    color: #ef7c94 !important;
  }
</style>



// WEBPACK FOOTER //
// src/views/PolicyServicing/Detail.vue